<template>
  <div class="signup-container vw-100 vh-100">
    <div
      class="signup-wrapper vh-100 w-50 bg-white d-flex flex-column p-5 overflow-y-auto"
    >
      <div class="text-start">
        <img src="../../assets/images/logos/living-dna-updated-logo.svg" alt="Logo" />
      </div>
      <div class="profile-picture-row">
        <h2>Add a profile picture</h2>
        <p>
          If you`'d like to, you can add a profile picture to help other users identify
          you. It's entirely optional and you can update, add, or delete your profile
          picture at any time from your profile settings
        </p>

        <!-- upload Image row -->
        <div class="upload-container">
          <div v-if="!imagePreview" class="upload-box" @click="uploadImage">
            <img class="mb-2" :src="Icon" alt="" />
            <p>Upload (JPEG, PNG, HEIC & BMP)</p>
            <input
              type="file"
              ref="fileInput"
              accept="image/*"
              @change="onFileChange"
              style="display: none"
            />
          </div>
          <div v-else class="preview-container">
            <img :src="imagePreview" alt="Image Preview" class="image-preview" />
            <button class="remove-btn" @click="removeImage">×</button>
          </div>
        </div>
        <!-- upload Image row -->

        <div class="action-cta-container">
          <button>Save</button>
          <button>No Thank You</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "../../assets/images/Login/upload-minimalistic-svgrepo-com 1.png";
export default {
  data() {
    return {
      imagePreview: null, // Store the preview URL
      Icon,
    };
  },
  methods: {
    // Handle the image upload and preview
    onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.imagePreview = URL.createObjectURL(file);
      }
    },
    // Simulate clicking on the input to upload an image
    uploadImage() {
      this.$refs.fileInput.click();
    },
    // Remove the image
    removeImage() {
      this.imagePreview = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = ""; // Safely reset the file input
      }
    },
  },
};
</script>

<style lang="scss">
.signup-container {
  overflow: hidden;
  position: relative;

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 200%;
    height: 200%;
    z-index: 0;
    background: url("@/assets/bg-bubble.png") 0 0 repeat;
  }

  &::before {
    top: 0%;
    left: -20%;
    transform: rotate(30deg);
  }

  &::after {
    top: -60%;
    left: -10%;
    transform: rotate(-30deg);
  }

  .signup-wrapper {
    margin-left: auto;
    border-top-left-radius: 105px;
    border-bottom-left-radius: 105px;
    height: 100vh;
    max-width: 819px;
    box-shadow: -7px 4px 12px 4px #00000040;
    z-index: 1;
    position: relative;

    .form-wrapper {
      font-family: Poppins;
      font-size: 16px;
      line-height: 24px;
    }

    h1 {
      font-size: 50px;
      font-weight: 600;
      line-height: 75px;
      letter-spacing: 0.08em;
      color: #1a3b84;
    }

    select,
    input[type="text"],
    input[type="email"],
    input[type="password"] {
      all: unset;
      padding: 18px;
      text-align: left;
      width: calc(100% - 50px);
      border-bottom: 1px solid #c7c7c7;
      font-size: 0.875rem;
      line-height: 26px;

      &,
      &:active,
      &:focus {
        background-color: white !important;
      }
    }

    .form-group {
      margin: 10px 0;

      .input-icon-container {
        position: relative;

        svg {
          position: absolute;
          top: 20px;
          left: 15px;
        }

        input {
          padding: 18px 25px 18px 50px;
          width: calc(100% - 75px);
        }
      }
    }

    .register-btn {
      padding: 18px 26px;
      background: #1a3b84;
      border-radius: 35px;
      color: #fff;
      border: none;
      width: 100%;
    }

    .privacy-terms {
      text-align: right;
      margin-top: auto;

      a {
        text-decoration: none;
        color: #9e9e9e;
        margin-left: 40px;

        font-size: 14px;
        font-weight: 500;
        line-height: 21px;

        &:hover {
          color: #1a3b84;
        }
      }
    }
  }
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}

.profile-picture-row {
  margin: 40px 0px;
  > h2 {
    color: #1a3b84;
    font-size: 35px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  > p {
    font-weight: 400;
    font-size: 18px;
    color: #b7b7b7;
  }
}

.upload-container {
  position: relative;
  top: 0;
  border: 1px dashed #c7c7c7;
  padding: 30px 20px;
  border-radius: 20px;
  max-width: 70%;
  margin: 30px auto;
  > div {
    > p {
      margin-bottom: 0rem;
    }
    > button {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: transparent;
      border-radius: 50px;
      width: 30px;
      height: 30px;
    }
  }
}

.preview-container {
  > img {
    width: 60%;
  }
}

.action-cta-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 65%;
  margin: 20px auto;
  > button {
    width: 100%;
    height: 58px;
    border-radius: 50px;
    border: none;
    margin: 10px 0px;
    font-weight: 500;
    font-size: 18px;
    background-color: transparent;
    &:nth-child(1) {
      background-color: #1a3b84;
      color: white;
    }
    &:nth-child(2) {
      border: 1px solid #c7c7c7;
      color: #666666;
    }
  }
}

@media screen and (max-width: 992px) {
  .signup-wrapper {
    width: 70% !important;
  }
}

@media screen and (max-width: 714px) {
  .signup-wrapper {
    width: 80% !important;
  }
}

@media screen and (max-width: 640px) {
  .action-cta-container,
  .upload-container {
    max-width: 100%;
  }
}

@media screen and (max-width: 598px) {
  .signup-wrapper {
    width: 95% !important;
  }
  .profile-picture-row > h2 {
    font-size: 26px;
  }
}
</style>
